export default __webpack_public_path__ + "static/media/ALLERGEN_LUPIN.3353eaee.png";